// Import React and Hooks
import React, { useState } from 'react'
// Import Components
import FloatImg from './FloatImg'



// Beer mask prop
interface beerMaskProp {
  fileImg:string,
  name?:string,
  textDedication?:string,
  canRotate?:boolean,
  additionalClass?:string
}

const BeerMask = ( { fileImg, name, textDedication, canRotate, additionalClass }:beerMaskProp ) => {



  // Use State
  const [ turnedBeer, setTurnedBeer ] = useState(false)



  // Function
  function renderBgBeerMask() {
    return <div className="beerMask__bg__side">
      <FloatImg
        additionalClass="shapesBeerMask1"
        alt="Flores y pajaro"
        speed={ 0.021 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/florecillas.png`} />
      {/* <img
        src={`${window.assetsURl}/imgs/shapes/shapes-beer.svg`}
        alt="Flores y pajaro"
        title="Flores y pajaro"
        className="beerMask__bg__img" /> */}
      {/* <FloatImg
        additionalClass="flowersBeerMask1"
        alt="Arreglo floral"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-6.svg`} />
      <FloatImg
        additionalClass="flowersBeerMask2"
        alt="Arreglo floral"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-arrangement-8.svg`} />
      <FloatImg
        additionalClass="flowerBeerMask1"
        alt="Flor"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/flower-13.svg`} />
      <FloatImg
        additionalClass="birdBeerMask1"
        alt="Colibrí"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/shapes/bird-2.svg`} />
      <FloatImg
        additionalClass="petalBeerMask1"
        alt="Pétalo de flor"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-4.svg`} />
      <FloatImg
        additionalClass="petalBeerMask2"
        alt="Pétalo de flor"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-1.svg`} />
      <FloatImg
        additionalClass="petalBeerMask3"
        alt="Pétalo de flor"
        speed={ 0.01 }
        revert={ true }
        src={`${window.assetsURl}/imgs/petals/petal-7.svg`} /> */}
    </div>
  }



  return (
    <section className={`beerMask ${ turnedBeer ? 'turned' : '' } ${ additionalClass ? additionalClass : ''}`}>
      <div className="beerMask__bg">
        { renderBgBeerMask() }
        { renderBgBeerMask() }
      </div>
      <div className="beerMask__clean">
        <img
          src={`${window.assetsURl}/imgs/product/beer-clean.png`}
          alt="Cerveza Victoria en lata"
          title="Cerveza Victoria en lata"
          className="beerMask__clean__img" />
      </div>
      <div className="beerMask__front">
        <img
          src={`${window.assetsURl}/imgs/product/beer-front-new.png`}
          alt="Vista frontal de la cerveza Victoria en lata"
          title="Vista frontal de la cerveza Victoria en lata"
          className="beerMask__front__img" />
        <img
          src={ fileImg }
          alt="Foto de persona"
          title="Foto de persona"
          className="beerMask__front__photo" />
        { name && (
          <p className="beerMask__front__name">
            { name }
          </p>
        ) }
      </div>
      { canRotate && (
        <>
          <div className="beerMask__back">
            <img
              src={`${window.assetsURl}/imgs/product/beer-back_new.png`}
              alt="Vista trasera de la cerveza Victoria en lata"
              title="Vista trasera de la cerveza Victoria en lata"
              className="beerMask__back__img" />
            { textDedication && (
              <p className="beerMask__text">
                { textDedication }
              </p>
            ) }
          </div>
          <div className="beerMask__controls">
            <button
              type="button"
              className="beerMask__btn"
              onClick={ () => setTurnedBeer( turnedBeer ? false : true ) } >
              Girar Lata
            </button>
          </div>
        </>
      ) }
    </section>
  )
}




export default BeerMask
